import React, { useCallback, useState } from "react";

export const useDitectInputTouched = <T extends HTMLElement>(
  onFocus: undefined | ((event: React.FocusEvent<T>) => void),
) => {
  const [touched, setTouched] = useState(false);

  const handleFocus = useCallback(
    (event: React.FocusEvent<T>) => {
      if (onFocus) {
        onFocus(event);
      }
      setTouched(true);
    },
    [onFocus],
  );

  return [
    touched,
    {
      "data-touched": touched,
      onFocus: handleFocus,
    },
  ] as const;
};
